@if (configuration.display) {
<a
    [href]="'tel:' + phoneNumber()"
    class="is-background-primary is-rounded is-font-h2"
>
    <fa-icon [icon]="['fas', configuration.icon]"></fa-icon>
    {{ phoneLabel() | rasPhone }}
</a>
}
